import React from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import BackgroundImage from '../shared/BackgroundImage';
import SectionTitle from '../shared/SectionTitle';
import JobsHeroImage from '../../images/bg-diagonal.webp';

const JobsListAnchorLink = ({ children }: { children: React.ReactNode }) => (
  <AnchorLink stripHash to="/jobs/#open-roles">
    <Text as="span" color="hoverBlue" fontWeight="bold" fontSize="lg">
      {children}
    </Text>
  </AnchorLink>
);

const Hero = () => (
  <BackgroundImage imageUrl={JobsHeroImage}>
    <Flex
      w="100%"
      minH="800px"
      h="fit-content"
      px={['4', '16']}
      pb={['6']}
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Box maxW="4xl" color="white">
        <SectionTitle
          title="Homeownership can be hard - let’s change that"
          subTitle="HOVER leverages patented technology to help people across the entire cycle of homeownership. With the power of 3D, we’re visualizing and unlocking the potential of every property. We’re excited for what’s to come and looking for creative problem solvers to join the team!"
        />
        <Text my="10">
          Check out our <JobsListAnchorLink>Open Roles</JobsListAnchorLink>
        </Text>
      </Box>
    </Flex>
  </BackgroundImage>
);
export default Hero;
